import apiService from 'frontcore/data/api-service/api-service'
import { defineStore } from 'pinia'
import { PROMISE_STATUS } from 'frontcore/constants/promises'
import { readonly, ref, Ref } from "vue"

const URL_PERIMETERS_ALLOWED = 'perimeters/allowed/'

export class PerimetersAllowedAPIError extends Error {}

type PerimetersAllowedAPIResponse = number[]

interface IAllowedPerimetersStore {
  allowedIds: Ref<Readonly<number[]>>
  clear: () => void
  fetch: () => Promise<void>
  userHasAccessToPerimeter: (perimeterId: number) => boolean
}

const useAllowedPerimetersStore = defineStore('allowedPerimetersForUser', (): IAllowedPerimetersStore => {

  const status = ref(PROMISE_STATUS.notStarted)
  const allowedIds: Ref<number[]> = ref([])

  const fetchAllowedPerimeters = async () => {
    const response = await apiService
      .buildRequest()
      .withSessionToken()
      .get<PerimetersAllowedAPIResponse>(URL_PERIMETERS_ALLOWED)
    return response.data
  }
  
  const fetch = async () => {
    try { 
      if (status.value === PROMISE_STATUS.notStarted) {
        status.value = PROMISE_STATUS.pending
        allowedIds.value = await fetchAllowedPerimeters()
        status.value = PROMISE_STATUS.complete
      }
    } catch {
      status.value = PROMISE_STATUS.notStarted
      throw new PerimetersAllowedAPIError()
    }
  }

  const userHasAccessToPerimeter = (perimeterId: number) => {
    return allowedIds.value.includes(perimeterId)
  }

  const clear = () => {
    allowedIds.value = []
    status.value = PROMISE_STATUS.notStarted
  }
    
  return {
    allowedIds: readonly(allowedIds),
    clear,
    fetch,
    userHasAccessToPerimeter,
  }
})

export default useAllowedPerimetersStore
